export default __webpack_public_path__ + "static/media/Ballroll_00143.eda6ba80.png";